import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Departement } from '../models/models';

const STORAGE_KEY_DEPT = 'app_departement';
const STORAGE_KEY_ALL  = 'app_all_mode';

const loadDeptFromStorage = (): Departement | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_DEPT);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const loadAllModeFromStorage = (): boolean =>
  localStorage.getItem(STORAGE_KEY_ALL) === '1';

interface AppState {
  selectedDepartement: Departement | null;
  isAllMode: boolean;
}

const initialState: AppState = {
  selectedDepartement: loadDeptFromStorage(),
  isAllMode: loadAllModeFromStorage(),
};

const AppSlice = createSlice({
  name: 'AppSlice',
  initialState,
  reducers: {
    setSelectedDepartement(state, action: PayloadAction<Departement | null>) {
      state.selectedDepartement = action.payload;
      state.isAllMode = false;
      localStorage.removeItem(STORAGE_KEY_ALL);
      if (action.payload) {
        localStorage.setItem(STORAGE_KEY_DEPT, JSON.stringify(action.payload));
      } else {
        localStorage.removeItem(STORAGE_KEY_DEPT);
      }
    },
    setAllMode(state) {
      state.selectedDepartement = null;
      state.isAllMode = true;
      localStorage.removeItem(STORAGE_KEY_DEPT);
      localStorage.setItem(STORAGE_KEY_ALL, '1');
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type === 'auth/logout',
      (state) => {
        state.selectedDepartement = null;
        state.isAllMode = false;
      }
    );
  },
});

export const { setSelectedDepartement, setAllMode } = AppSlice.actions;
export default AppSlice.reducer;
